/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Selection_Userfallback1Inputs */

const es_tenant_selection_userfallback1 = /** @type {(inputs: Tenant_Selection_Userfallback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario`)
};

const en_tenant_selection_userfallback1 = /** @type {(inputs: Tenant_Selection_Userfallback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Tenant_Selection_Userfallback1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tenant_selection_userfallback1 = /** @type {((inputs?: Tenant_Selection_Userfallback1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Selection_Userfallback1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tenant_selection_userfallback1(inputs)
	return en_tenant_selection_userfallback1(inputs)
});
export { tenant_selection_userfallback1 as "tenant-selection.userFallback" }